import React from 'react';

const IconFolder = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="23.708" height="18.453" viewBox="0 0 23.708 18.453">
    <path id="folder-open" d="M6.088,38.59H19.771V36.613a1.978,1.978,0,0,0-1.977-1.977H11.2L8.568,32H1.977A1.977,1.977,0,0,0,0,33.977V47.5l3.729-7.46A2.626,2.626,0,0,1,6.088,38.59ZM22.37,39.908H6.088a1.313,1.313,0,0,0-1.178.729L0,50.453H18.416a1.318,1.318,0,0,0,1.179-.729l3.954-7.908A1.3,1.3,0,0,0,22.37,39.908Z" transform="translate(0 -32)" fill="#1d3853" />
  </svg>
);
export default IconFolder;
